export const DataForViewResults = function () {
    this.employeeReviewScore = {};
    this.reviewAnswerResult  = [];
};